import { useEffect, useState } from "react";
import { fetchFormThemes } from "../api/formThemes";
import { FALLBACK_FORM_THEMES } from "../lib/forms/appearance";
import type { FormThemesCatalog } from "../types/appearance";

export function useFormThemes() {
  const [catalog, setCatalog] =
    useState<FormThemesCatalog>(FALLBACK_FORM_THEMES);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      const next = await fetchFormThemes();
      if (!cancelled) {
        setCatalog(next);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { catalog, isLoading };
}
